import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();

// Removido listener conflitante - o componente PWAInstallPrompt agora gerencia isso
// window.addEventListener('beforeinstallprompt', ...) foi movido para o componente React

reportWebVitals();
